import React from 'react';
import StaffManagementPage from './StaffManagementComponents/StaffManagementPage';

const StaffManagementView = (props) => {
  return <StaffManagementPage {...props} />;
};

export default StaffManagementView;
